import { render } from "./itemList_coinFutures.vue?vue&type=template&id=ef98f316"
import script from "./itemList_coinFutures.vue?vue&type=script&lang=js"
export * from "./itemList_coinFutures.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__